module.exports = __webpack_public_path__ + "static/media/image_teal@2x-min.d03926b2.jpg";